/**
 * When the type filter is active, only employees with at least one matching
 * block in the current viewport should remain visible (incl. absences).
 */
export function employeeIdsWithVisibleBlocks(
  blocks: ReadonlyArray<{
    primaryEmployeeId?: string | null;
    assigneeEmployeeIds?: readonly string[];
  }>,
): Set<string> {
  const ids = new Set<string>();
  for (const b of blocks) {
    if (b.primaryEmployeeId) ids.add(b.primaryEmployeeId);
    for (const id of b.assigneeEmployeeIds ?? []) ids.add(id);
  }
  return ids;
}

export function shouldRestrictEmployeesToTypeMatches(typeFilter: readonly string[]): boolean {
  return typeFilter.length > 0;
}
